export interface IEditFixedPhrase {
  editFixedPhrase(): Promise<void>;
}

export function instanceOfIEditFixedPhrase(instance: any): instance is IEditFixedPhrase {
  return (instance.editFixedPhrase !== undefined);
}
